import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconMenu = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M7.287 15.041A1.99 1.99 0 0 0 5.86 16.07c-.24.44-.296 1.101-.134 1.588.136.41.612.944 1.035 1.16l.311.159h49.856l.288-.15c.383-.198.779-.59.967-.958.128-.25.153-.394.153-.876 0-.519-.019-.61-.19-.919-.323-.583-.815-.925-1.491-1.036-.448-.074-48.933-.07-49.368.004m-.413 15.107c-.395.152-.857.59-1.06 1.005-.213.438-.236 1.085-.056 1.565.17.453.587.897 1.043 1.109l.335.156h49.728l.335-.156a1.97 1.97 0 0 0 1.157-1.923c-.04-.79-.54-1.494-1.248-1.759-.344-.129-.43-.129-25.126-.126-24.462.004-24.786.005-25.108.13m.277 14.913c-.559.133-1.045.527-1.336 1.083-.125.24-.15.384-.15.864 0 .5.023.619.17.9.204.387.6.76 1.005.947l.296.137h49.728l.296-.137c.406-.188.8-.56 1.004-.947.148-.281.17-.4.17-.9s-.022-.619-.17-.9a2.3 2.3 0 0 0-1.004-.947l-.296-.137-24.736-.01c-14.276-.005-24.838.014-24.977.047" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconMenu.displayName = 'IconMenu';